import { createBrowserRouter } from "react-router-dom";
import { RootLayout } from "@layouts/root-layout";
import { RootErrorBoundary } from "@app/router/root-error-boundary";
import { ProtectedRoute } from "@app/router/guards/protected-route";
import { GuestRoute } from "@app/router/guards/guest-route";
import { ROUTES } from "@utils/navigation/routes";
import {
  lazyAccountPage,
  lazyAccountSectionLayout,
  lazyAppShellLayout,
  lazyAuthCallbackPage,
  lazyAuthLayout,
  lazyBillingPage,
  lazyCarsPage,
  lazyCommuteDetailPage,
  lazyCommutesPage,
  lazyFeedbackPage,
  lazyForgetPasswordPage,
  lazyHomePage,
  lazyLandingPage,
  lazyNotFoundPage,
  lazyNotificationsPage,
  lazyNotificationSettingsPage,
  lazyProfilePage,
  lazyPublicLayout,
  lazyRequestDetailPage,
  lazyRequestsPage,
  lazyResetPasswordPage,
  lazySearchPage,
  lazySignInPage,
  lazySignUpPage,
  lazyVerifyPage,
} from "@app/router/lazy-routes";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RootErrorBoundary />,
    children: [
      { path: ROUTES.LANDING, lazy: lazyLandingPage },

      {
        lazy: lazyPublicLayout,
        children: [{ path: ROUTES.SEARCH, lazy: lazySearchPage }],
      },

      {
        element: <GuestRoute />,
        children: [
          {
            lazy: lazyAuthLayout,
            children: [
              { path: ROUTES.AUTH.SIGNIN, lazy: lazySignInPage },
              { path: ROUTES.AUTH.SIGNUP, lazy: lazySignUpPage },
              { path: ROUTES.AUTH.VERIFY, lazy: lazyVerifyPage },
              {
                path: ROUTES.AUTH.FORGET_PASSWORD,
                lazy: lazyForgetPasswordPage,
              },
            ],
          },
        ],
      },

      {
        lazy: lazyAuthLayout,
        children: [
          { path: ROUTES.AUTH.RESET_PASSWORD, lazy: lazyResetPasswordPage },
        ],
      },

      { path: ROUTES.AUTH.CALLBACK, lazy: lazyAuthCallbackPage },

      {
        element: <ProtectedRoute />,
        children: [
          {
            lazy: lazyAppShellLayout,
            children: [
              { path: ROUTES.HOME, lazy: lazyHomePage },
              { path: ROUTES.COMMUTES, lazy: lazyCommutesPage },
              {
                path: `${ROUTES.COMMUTES}/:id`,
                lazy: lazyCommuteDetailPage,
              },
              { path: ROUTES.REQUESTS, lazy: lazyRequestsPage },
              {
                path: `${ROUTES.REQUESTS}/:id`,
                lazy: lazyRequestDetailPage,
              },
              { path: ROUTES.NOTIFICATIONS, lazy: lazyNotificationsPage },
              {
                path: ROUTES.ACCOUNT,
                children: [
                  { index: true, lazy: lazyAccountPage },
                  {
                    lazy: lazyAccountSectionLayout,
                    children: [
                      { path: "profile", lazy: lazyProfilePage },
                      { path: "feedback", lazy: lazyFeedbackPage },
                      { path: "car", lazy: lazyCarsPage },
                      { path: "billing", lazy: lazyBillingPage },
                      { path: "notifications", lazy: lazyNotificationSettingsPage },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },

      { path: "*", lazy: lazyNotFoundPage },
    ],
  },
]);
